export const remove_from_cart = (state) => {
  state.accessories.forEach((accessory) => {
    if(accessory.line_item_id) state.accessoriesToDestroy.push(accessory.line_item_id)
    const foundIndex = state.accessoriesListInfo.findIndex((info) => info.id === accessory.product_id);
    state.accessoriesListInfo[foundIndex].selected = false;
  })
  state.accessories = [];
}

export const remove_accessory_from_cart = (state, product_id) => {
  const foundIndex = state.accessories.findIndex((accessory) => accessory.product_id === product_id)
  const foundInfoIndex = state.accessoriesListInfo.findIndex((info) => info.id === product_id);
  state.accessoriesListInfo[foundInfoIndex].selected = false;
  if(state.accessories[foundIndex].line_item_id) state.accessoriesToDestroy.push(state.accessories[foundIndex].line_item_id)
  state.accessories = state.accessories.filter((accessory) => accessory.product_id !== product_id)
}